import { OPERATIONS } from './apiModules'

import { post } from '@/utils/request'

const OPERATION_PREFIX = `${OPERATIONS}/analysis`

export function getContentAnalysisList(
  params = {
    page: 0,
    limit: 20,
    searchKeyword: ''
  }
) {
  return post(`${OPERATION_PREFIX}/clickArticle`, params)
}

export function getFileAnalysisList(
  params = {
    page: 0,
    limit: 20,
    searchKeyword: ''
  }
) {
  return post(`${OPERATION_PREFIX}/clickFile`, params)
}
